/*
 * @Author: 李朋飞
 * @Date: 2021-07-09 17:58:00
 * @LastEditTime: 2021-07-09 17:58:18
 * @Description: 
 */
import MaxImg from './MaxImg';

export default {
  install(Vue) {
    Vue.component('MaxImg', MaxImg);
  }
};


// WEBPACK FOOTER //
// ./src/components/MaxImg/index.js